import React, { ReactNode } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { DialogWindow } from '@/components/DialogWindow';
import Button from '@/components/core/Button';

const messages = defineMessages({
  title: {
    id: 'confirm_dialog.are_you_sure',
    defaultMessage: 'Are you sure?',
  },
  cancel: {
    id: 'filter_management_dialog.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'filter_management_dialog.yes',
    defaultMessage: 'Yes',
  },
});

interface ConfirmDialogProps {
  open: boolean;
  titleLabel?: React.ReactNode;
  confirmLabel?: React.ReactNode;
  cancelLabel?: React.ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  children?: ReactNode;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  children,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  titleLabel,
}) => {
  return (
    <DialogWindow
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen && onCancel) {
          onCancel();
        }
      }}
      className="!max-w-[500px]"
      title={titleLabel ?? <FormattedMessage {...messages.title} />}
      content={
        <div className="whitespace-pre-wrap text-base text-text-700">
          {children}
        </div>
      }
      footer={
        <>
          {onCancel && (
            <Button variant="ghost" onClick={() => onCancel()}>
              {cancelLabel ?? <FormattedMessage {...messages.cancel} />}
            </Button>
          )}
          <Button variant="filled" onClick={() => onConfirm?.()}>
            {confirmLabel ?? <FormattedMessage {...messages.confirm} />}
          </Button>
        </>
      }
    />
  );
};

export default ConfirmDialog;
